<template>
  <v-list-item 
    @click="showDialog()"
    :disabled="!device.isOnline() || !device.hasFeature('services.cloud.commands_interface.tcp_connection_check.enabled')"
  >
    <v-dialog
      v-if="device"
      v-model="showControl"
      max-width="540px"
    >
      <videon-card heading="TCP Connection Check" showClose="true" :ignoreHeaderMargin="!isVersionSupported" @close="showControl = false">
        <v-alert
          text
          color="orange"
          icon="mdi-alert-outline"
          v-if="!isVersionSupported"
        >
          This feature is not supported on {{ this.device.cloud_version.original }}, please update your cloud agent.
        </v-alert>
        <v-card-text>
          <v-form ref="form">
            <v-row class="my-5" no-gutters>
              <v-col cols="8">
                <v-text-field
                  class="mr-3"
                  v-model="host"
                  :rules="$validations.destinationAddressValidation"
                  @change="targetChanged"
                  label="Host"
                  required
                  outlined
                  hide-details="auto"
                  :disabled="processing"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="port"
                  type="number"
                  @change="targetChanged"
                  label="Port"
                  required
                  outlined
                  hide-details="auto"
                  :disabled="processing"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-alert dense outlined type="error" v-if="commandStatus == 'rejected' || commandStatus == 'failed'" >
            {{ commandMessage }}
          </v-alert>
          <v-alert dense outlined type="info" v-if="commandStatus == 'complete'" >
            {{ commandMessage }}
          </v-alert>
          
          <div v-if="processing">
            <v-progress-linear
              color="primary"
              indeterminate
              buffer-value="0"
              class="mb-3"
            ></v-progress-linear>
          </div>
          
          <div class="text-right">
            <v-btn
              class="ma-1"
              color="secondary"
              @click="showControl = false"
              text
            >
              Cancel
            </v-btn>
            
            <v-btn
              class="ma-1"
              color="primary"
              @click="runCheck()"
              :disabled="!isVersionSupported || processing"
            >
              Check Target
            </v-btn>
            
          </div>
        </v-card-text>
      </videon-card>
    </v-dialog>
    
    <v-list-item-title class="pr-2">
      <v-icon class="material-icons-outlined">lan</v-icon> 
      TCP Connection Check
    </v-list-item-title>
  </v-list-item>
</template>

<script>
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'TCPConnectionCheck',
    
    props: ['device'],
    
    data() {
      return {
        minimumAgentVersion: this.$helpers.parseVersion('cloud', 'V1.32.1'),
        
        showControl: false,
        
        host: '',
        port: 80
      }
    },
    mounted() {
      
    },
    computed: {
      ...mapGetters('user', ['isDeviceAdmin']),
      
      isVersionSupported() {
        if (this.$helpers.versionCheck(this.minimumAgentVersion, this.device.cloud_version)) {
          return true
        }
        return false
      },
      
      processing() {
        if (this.device.isCommandProcessing()) {
          return true
        }
        return false
      },
      
      commandStatus() {
        return this.device.command_status
      },
      commandMessage() {
        return this.device.command_message
      },
    },

    methods: {
      showDialog() {
        this.device.resetCommandState()
        this.showControl = true
      },
      targetChanged() {
        this.$refs.form.validate()
      },
      runCheck() {
        console.log('TCPConnectionCheck ' + this.device.device_guid + ' runCheck ' + this.host + ':' + this.port)
        var hostnameValidation = this.$validations.isValidHostname(this.host)
        
        if (this.host && this.port && hostnameValidation) {
          this.device.runCommand('tcp_connection_check', {'host': this.host, 'port': this.port})
        }
      },
    }
  }
</script>